// BCM-898 · PA9 gate — "New logic change" note on the Pre-GRN Check Failed
// slide: the Pre-IBD/Pre-GRN checks (the same ones PA8 runs) must keep running
// even once the workflow raises showGenerateGRNActionButton /
// showCreateIBDActionButton (status 108/109 "Pre-IBD/GRN Check Completed").
// The Generate IBD/GRN screen (PA9) is shown only once those checks all pass;
// while any check is still failing, PA8's failure screen keeps showing instead.
import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { checkConsumedBatchExpiry } from "../api/goodsReceiptApi";

// Same signal PA8 uses to pick Pre-IBD vs Pre-GRN wording/validation.
const isGRNFlow = (detail) => {
  const seq = (detail && detail.progressBar && detail.progressBar.statusSequence) || [];
  return seq.some((s) => s && s.statusName === "GRN Generated");
};

// { loading, allPassed }. allPassed is null while loading/unknown; a missing or
// malformed response never blocks generation (same "missing data never
// suppresses" direction resolvePendingAction already follows elsewhere).
export const usePreIBDGRNGate = (row, detail) => {
  const [state, setState] = useState({ loading: true, allPassed: null });
  const mountedRef = useRef(true);
  const cancelRef = useRef(null);

  useEffect(() => {
    mountedRef.current = true;
    return () => {
      mountedRef.current = false;
      if (cancelRef.current) cancelRef.current.cancel("leaving PA9 pre-check gate");
    };
  }, []);

  useEffect(() => {
    if (!row || !row.schrockenDeliveryScheduleBatchID) {
      setState({ loading: false, allPassed: true });
      return;
    }
    setState({ loading: true, allPassed: null });
    if (cancelRef.current) cancelRef.current.cancel("superseded PA9 gate fetch");
    const source = axios.CancelToken.source();
    cancelRef.current = source;

    checkConsumedBatchExpiry(
      {
        schrockenDeliveryScheduleBatchID: Number(row.schrockenDeliveryScheduleBatchID),
        scheduleAgreementNumber: row.scheduleAgreementNumber,
        schrockenSLID: row.schrockenSLID,
        collaboratorTypeId: 1,
        IBDValidation: true,
        GRNValidation: isGRNFlow(detail),
      },
      source.token
    )
      .then((res) => {
        if (!mountedRef.current) return;
        const data = res && res.data;
        if (data && Array.isArray(data.checks) && data.checks.length > 0) {
          setState({ loading: false, allPassed: data.checks.every((c) => c && c.passed) });
        } else {
          setState({ loading: false, allPassed: true });
        }
      })
      .catch((err) => {
        if (axios.isCancel(err)) return;
        if (!mountedRef.current) return;
        setState({ loading: false, allPassed: true });
      });
  }, [row, detail]);

  return state;
};
